import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";

const CustomerHistoryTableData = ({ data, index, currentPage }) => {
  const navigate = useNavigate();
  return (
    <tr className="table-rows1" key={data?.id}>
      <td className="table-each-row-data">
        {(currentPage - 1) * 10 + (index + 1)}
      </td>
      <td className="table-each-row-data">
        {data?.customer_type == "doctor" ? data?.code : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.customer_type == "doctor"
          ? `DR. ${data?.name.toUpperCase()}`
          : "--"}
      </td>
      <td className="table-each-row-data">{data?.mobile ?? "--"}</td>
      <td className="table-each-row-data">
        {data?.pharmacy_type
          ? data?.pharmacy_type.charAt(0).toUpperCase() +
            data?.pharmacy_type.slice(1)
          : "--"}
      </td>
      {data?.status ? (
        <td className="table-each-row-data color-green">
          <span className="fw_600">Active</span>
        </td>
      ) : (
        <td className="table-each-row-data color-danger">
          <span className="fw_600">Inactive</span>
        </td>
      )}
      <td className="table-each-row-data">
        {data?.city?.name ? data?.city?.name : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.city?.name ? data?.city?.name : "--"}
      </td>
      <td className="table-each-row-data">
        {data?.city?.name ? data?.city?.name : "--"}
      </td>

      <td className="table-each-row-data">
        {data?.doctorVersion?.updatedByAdmin
          ? data?.doctorVersion?.updatedByAdmin
          : "--"}
      </td>
      <td className="table-each-row-data">
        {moment(data?.updatedAt).format("DD MMM YYYY, HH:mm A")}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() =>
              navigate(
                `/customers/onboarded-doctors/version-history-detail/${data.id}`,
                {
                  state: {
                    user_type: data?.customer_type,
                    pharmacy_id:
                      data?.customer_type == "pharmacy" ? data.id : null,
                    doctor_id: data?.customer_type == "doctor" ? data.id : null,
                  },
                }
              )
            }
          >
            {"view"}
          </button>
        </div>
      </td>
    </tr>
  );
};

export default CustomerHistoryTableData;
